module.exports = __webpack_public_path__ + "a6b4238cecfda6d4781cdf70002980d7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/home/background.png
// module id = ./assets/images/home/background.png
// module chunks = 0